import styled from 'styled-components';
import { buttonBase } from '../styled';
import { getButtonAppearance, getIconButtonSize } from '../utils';
import { getLoaderSize } from '../utils/getLoaderSize';
import { iconButtonBase } from '../utils/getToggleButtonAppearance';
export const IconButtonContainer = styled.button `
  ${buttonBase}
  ${iconButtonBase}

  ${(props) => getButtonAppearance(props.appearance)};
  ${(props) => getIconButtonSize(props.size)};
  ${(props) => getLoaderSize(props.size)};
`;
